/*
 * Copyright 2026 Sony Corporation
 */

/** Starts a file download from a link that sends the file as an attachment, without leaving the page. */
export const startDownload = (url: string, filename: string): void => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noreferrer';
  document.body.append(link);
  link.click();
  link.remove();
};

/** 45 000 as 45 s, 260 000 as 4 min 20 s. */
export const formatDuration = (ms: number): string => {
  const seconds = Math.round(ms / 1000);
  return seconds < 60 ? `${seconds} s` : `${Math.floor(seconds / 60)} min ${seconds % 60} s`;
};

/** 950 as it is, 3 200 as 3.2k, 12 400 as 12k. */
export const formatTokens = (tokens: number): string =>
  tokens < 1_000
    ? String(tokens)
    : tokens < 10_000
      ? `${(tokens / 1_000).toFixed(1)}k`
      : `${Math.round(tokens / 1_000)}k`;
